import { ProductVariantViewModel, ProductViewModel } from '@/types/api'

export const generateImageAlt = (index: number, data?: ProductViewModel, selectedVariant?: ProductVariantViewModel) => {
    const name = data?.nameFa || ''
    const brand = data?.brand?.nameFa || ''
    const colorName = selectedVariant?.color?.name

    const generatedH1 = `${name} ${brand}${colorName ? ' ' + colorName : ''}`

    const alt =
        (selectedVariant ? generatedH1 : data?.pageH1 || generatedH1) +
        (index >= 1 ? ' - ' + index.toString().padStart(2, '0') : '')

    return alt
}
